import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import { logoutCloudApi } from './util/fetchHomeys.js';

const Header = ({ user, setView, setInstallerInformationOpen, view, isInstaller }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const avatarRef = useRef(null);

    const toggleMenu = () => {
        setMenuOpen((prev) => !prev);
    };

    const handleLogout = async () => {
        await logoutCloudApi();
        setMenuOpen(false);
        window.location.reload();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                avatarRef.current &&
                !avatarRef.current.contains(event.target)
            ) {
                setMenuOpen(false);
            }
        };

        if (menuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOpen]);


    return (
        <header className={`App-header${view !== 'map' ? ' App-header-border' : ''}`}>
            <div className="Header-left">
                <a className="Header-logo-link" rel="noreferrer" href="https://homey.app" target="_blank">
                    <img src="https://etc.athom.com/logo/transparent/256.png" alt="Homey logo" className="Header-logo" />
                </a>
                <h1 className="Header">Homey for Installers</h1>
            </div>
            <div className="Header-middle">
                <button
                    className={`Header-button ${view === 'list' ? 'Header-button-selected' : ''}`}
                    onClick={() => setView('list')}
                    disabled={!isInstaller}
                >
                    <svg
                        className={`Header-icon ${view === 'list' ? 'Header-icon-selected' : ''}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 12 12"
                        fill="currentColor"

                    >
                        <path
                            fill="currentColor"
                            d="M0.89999998 4.1805553L11.1 4.1805553C11.597056 4.1805553 12 4.5816336 12 5.0763888L12 5.6736112C12 6.1683664 11.597056 6.5694447 11.1 6.5694447L0.89999998 6.5694447C0.40294373 6.5694447 0 6.1683664 0 5.6736112L0 5.0763888C0 4.5816336 0.40294373 4.1805553 0.89999998 4.1805553ZM0.89999998 0L11.1 0C11.597056 0 12 0.40107825 12 0.89583331L12 1.4930556C12 1.9878106 11.597056 2.3888888 11.1 2.3888888L0.89999998 2.3888888C0.40294373 2.3888888 0 1.9878106 0 1.4930556L0 0.89583331C0 0.40107825 0.40294373 0 0.89999998 0ZM0.89999998 8.3611107L11.1 8.3611107C11.597056 8.3611107 12 8.7621889 12 9.2569447L12 9.854167C12 10.348922 11.597056 10.75 11.1 10.75L0.89999998 10.75C0.40294373 10.75 0 10.348922 0 9.854167L0 9.2569447C0 8.7621889 0.40294373 8.3611107 0.89999998 8.3611107Z" />
                    </svg>
                    List
                </button>
                <button
                    className={`Header-button ${view === 'map' ? 'Header-button-selected' : ''}`}
                    onClick={() => setView('map')}
                    disabled={!isInstaller}
                >
                    <svg
                        className={`Header-icon ${view === 'map' ? 'Header-icon-selected' : ''}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 742 1028"
                        fill="currentColor"
                    >
                        <path
                            fill="currentColor"
                            d="M370.85446 0C166.3642 0 0 166.3642 0 370.85245C0 624.62878 331.87842 997.18719 346.00842 1012.9232C359.28043 1027.7052 382.45245 1027.6792 395.70047 1012.9232C409.83051 997.18719 741.70892 624.62878 741.70892 370.85245C741.70892 166.3642 575.34271 0 370.85446 0ZM370.85446 557.43866C267.97034 557.43866 184.27022 473.73657 184.27022 370.85245C184.27022 267.96832 267.97232 184.26822 370.85446 184.26822C473.73657 184.26822 557.43671 267.97034 557.43671 370.85446C557.43671 473.73859 473.73657 557.43866 370.85446 557.43866Z" />
                    </svg>
                    Map
                </button>
            </div>
            <div className="Header-right">
                {user && user.avatar && (
                    <>
                        <div className="Header-user" ref={avatarRef} onClick={toggleMenu}>
                            <span className="Header-username">
                                {user?.firstname} {user?.lastname}
                            </span>
                            <img
                                src={user.avatar.small}
                                alt="User Avatar"
                                className="Header-avatar"
                            />
                        </div>

                        {menuOpen && (
                            <div className="Header-menu" ref={menuRef}>
                                <button
                                    className="Header-menu-item"
                                    onClick={() => {
                                        setMenuOpen(false);
                                        window.open("https://support.homey.app/hc/en-us", "_blank");
                                    }}
                                >
                                    <img src="/support.svg" alt="" className="Header-menu-icon" />
                                    Support
                                </button>
                                <button
                                    className="Header-menu-item"
                                    onClick={() => window.open(`https://accounts.athom.com/profile/${user.id}`, '_blank')}
                                >
                                    <img src="/account.svg" alt="" className="Header-menu-icon" />
                                    My Account
                                </button>
                                <button
                                    className="Header-menu-item"
                                    onClick={() => {
                                        setInstallerInformationOpen(true);
                                        setMenuOpen(false);
                                    }}
                                >
                                    <img src="/idbadge.svg" alt="" className="Header-menu-icon" />
                                    My Installer Details
                                </button>
                                <button onClick={handleLogout} className="Header-menu-item">
                                    <img src="/logout.svg" alt="" className="Header-menu-icon" />
                                    Sign Out
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>

        </header>
    );
};

export default Header;